/* story-zone-map — links each index row to its pin on the fw-adh zone map:
   hovering a row enlarges its pin (and hovering a pin marks its row).
   Pure enhancement: the map and list read the same without JS. */
(() => {
  if (customElements.get('story-zone-map')) return;

  class StoryZoneMap extends HTMLElement {
    connectedCallback() {
      this.pins = [...this.querySelectorAll('.story-zmap__pin')];
      this.rows = [...this.querySelectorAll('.story-zmap__row')];
      const bind = (el) => {
        const zone = el.dataset.zone;
        el.addEventListener('mouseenter', () => this.mark(zone));
        el.addEventListener('mouseleave', () => this.mark(null));
      };
      this.rows.forEach(bind);
      this.pins.forEach(bind);
    }

    mark(zone) {
      [...this.pins, ...this.rows].forEach((el) => el.classList.toggle('is-active', el.dataset.zone === zone));
    }
  }

  customElements.define('story-zone-map', StoryZoneMap);
})();
